module.exports = __webpack_public_path__ + "static/media/userunknow.2b428bdf.jpg";